import React, { useState, useEffect } from "react";

import { TextField, Container, Button } from "@mui/material";
import { Typography, Box, Grid } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import {
  getGuardianOridinance,
  postGuardianOridinance,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const EmergencyFolderWishes = (props) => {
  let uID = getUserIdFromLocalStorage();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [values, setValues] = useState([{ text: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  async function fetchData() {
    props.setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getGuardianOridinance(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (
          result.payLoad.guardianWishes !== null &&
          result.payLoad.guardianWishes?.length > 0
        ) {
          setValues(result.payLoad.guardianWishes);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      props.setButtonDisabled(false);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const payload = {
      ...data,
      guardianWishes: [...values],
      guardianEmergencyStepStatus: values[0].text ? 2 : 0,
    };
    const result = await postGuardianOridinance(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      props.next();
    }
    props.setButtonDisabled(false);
  };

  const addValue = () => {
    setValues([...values, { text: "" }]);
  };
  const handleValueChange = (index, e) => {
    const tempValues = [...values];
    tempValues[index].text = e.target.value;
    setValues(tempValues);
  };
  return (
    <form
      id="form_submit"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(values);
      }}
    >
      <Container
        className="summary-table documents-card-height"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Box
            sx={{
              textAlign: "center",
              marginTop: "10px",
              paddingTop: "20px",
            }}
            width="60%"
            className="documents-card-height"
          >
            <Typography variant="p" paragraph align="left" color="color.black">
              {t("guardian-desc")}
            </Typography>
            {/* <Typography
              sx={{ mt: 5 }}
              variant="p"
              paragraph
              align="left"
              color="color.black"
            >
              {t("emergency-folder-text")}
            </Typography> */}
            {values.map((jump, index) => (
              <Box key={"jump" + index}>
                <TextField
                  variant="standard"
                  margin="dense"
                  value={jump.text}
                  onChange={(e) => handleValueChange(index, e)}
                  fullWidth
                />
              </Box>
            ))}

            <Typography sx={{ mt: 2, display: "flex" }}>
              <SecondaryButton
                title={
                  <>
                    <Typography
                      sx={{
                        fontWeight: 900,
                        fontSize: "1.5rem",
                        position: "absolute",
                        top: "-10%",
                        left: "1rem",
                      }}
                    >
                      +
                    </Typography>{" "}
                    <Typography
                      sx={{
                        fontSize: "14px",
                        marginLeft: "1.5rem",
                      }}
                    >
                      {t("add-more-rows")}
                    </Typography>
                  </>
                }
                textTransform="initial"
                fontWeight="normal"
                bgColor="#DEDEDE"
                borderRadius="40px"
                padding="2px auto"
                width="content-fit"
                border="none"
                color="color.black"
                hoverBgColor="#DEDEDE"
                click={addValue}
              />
            </Typography>
          </Box>
        )}
      </Container>
    </form>
  );
};

export default EmergencyFolderWishes;
